import { Theme } from '@mui/material';

export const MuiTextField = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        variants: [
          {
            props: { variant: 'outlined' },
            style: {
              '&.MuiFormControl-root': {
                width: '100%',
                position: 'relative',
              },
              '& .MuiInputBase-root': {
                width: '100%',
                fontFamily: 'inherit',
                background: theme.palette.gray[150],
                paddingRight: '20px',
              },
            },
          },
        ],
      },
    },
  };
};
